import React from 'react';
import { Helpers } from '../../core/src/helpers';
import Link from '../../shared/components/hyperlink';

import '../css/pdp-value-props.less';

const PDPValueProp = ({ configLink, configText, customClass, customCSS }) => {
    const DEFAULT_VP = { text:"Weekly deals! Shop our best deals of the week.", link: "/slp/weekly-deals" };
    const link = configLink || DEFAULT_VP.link;
    const text = configText || DEFAULT_VP.text;
    const isAbsolute = (/^(https?:)?\/\//i).test(link);
    return (
        <div className={`pdp-vp-container${customClass ? ` ${customClass}` : ''}`}>
            <style dangerouslySetInnerHTML={Helpers.createMarkup(customCSS)}></style>
            <Link className='pdp-vp-link' to={link} newTab={isAbsolute}>
                <p dangerouslySetInnerHTML={Helpers.createMarkup(text)}></p>
            </Link>
        </div>
    )
}

export default PDPValueProp;

